import { render, staticRenderFns } from "./contentLibraryView.vue?vue&type=template&id=40897c0e&scoped=true"
import script from "./contentLibraryView.vue?vue&type=script&lang=js"
export * from "./contentLibraryView.vue?vue&type=script&lang=js"
import style0 from "./contentLibraryView.vue?vue&type=style&index=0&id=40897c0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40897c0e",
  null
  
)

export default component.exports